import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';
import { PartnerStateService } from '../services/partner-state.service';
import { ShopSettingsService } from '../../general/services/shop-settings.service';

@Injectable()
export class PartnerProfileGuard implements CanActivate {

  constructor(
    private router: Router,
    private partnerStateService: PartnerStateService,
    private shopSettingsService: ShopSettingsService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (this.shopSettingsService.isVUMode) {
      this.router.navigate(['']);
      return false;
    }

    if (this.partnerStateService.loggedInPartner) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
